import { Button, ButtonProps } from 'antd'
import styled, { css } from 'styled-components'
import {
  highlightStyles,
  HighlightType,
  highlightTypes,
} from '../constants/constants'

interface StyledActionButtonProps extends ButtonProps {
  $highlight?: HighlightType
}

const getHighlightCSS = ($highlight?: HighlightType) => {
  if (!$highlight || $highlight === highlightTypes.NONE) return ''

  const style = highlightStyles[$highlight as keyof typeof highlightStyles]
  if (!style) return ''

  return css`
    border-color: ${style.borderColor} !important;
    box-shadow: ${style.boxShadow} !important;
  `
}

const HighlightActionButton = styled(Button)<StyledActionButtonProps>`
  ${({ $highlight }) =>
    !$highlight || $highlight === highlightTypes.NONE
      ? ''
      : css`
          &:not(:disabled),
          &:hover:not(:disabled) {
            ${getHighlightCSS($highlight)}
          }
        `}

  &:focus,
  &:focus-visible {
    outline: none;
  }
`

export default HighlightActionButton
